
import React, { useEffect, useState } from "react";
import { Modal, Button, InputGroup, Form } from "react-bootstrap";

import UploadImageComponent from "../UploadImageComponent";
import convertNumber from "../../helpers/convertNumber";
import { END_IMAGE } from "../../constants";
export default function PopUpUpdatePayLoan({
  open,
  onClose,
  onSubmit,
  installmentData,
  memberData,
}) {
  // state
  const [formData, setFormData] = useState();
  const [disableButton, setDisableButton] = useState(false);

  // useEffect

  return (
    <Modal show={open} onHide={onClose} backdrop="static" size="md">
      <Modal.Header
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
          fontWeight: 700,
        }}
      >
        ປ້ອນຂໍ້ມູນຊຳລະເງິນ
      </Modal.Header>
      <Modal.Body
        style={{
          boxSizing: "border-box",
          overflow: "auto",
          width: "100%",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ງວດທີ</Form.Label>
          <Form.Control disabled value={installmentData?.installmentNoteNo} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຊື່ບັນຊີ</Form.Label>
          <Form.Control disabled value={memberData?.fullName} />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຈຳນວນເງິນ (ກີບ)</Form.Label>
          <Form.Control
            disabled
            value={convertNumber(installmentData?.totalRepayment)}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຄ່າປັບໄໝ (ກີບ)</Form.Label>
          <Form.Control
            disabled
            value={convertNumber(installmentData?.lateFeesAmount)}
          />
        </div>
        <div style={{ marginBottom: 20 }}>
          <Form.Label>ຮູບພາບຢືນຢັນ</Form.Label>
          <UploadImageComponent
            src={
              formData?.installmentImage
                ? END_IMAGE + formData?.installmentImage
                : ""
            }
            style={{ width: "100%", height: "200px" }}
            onChange={(e) => {
              setFormData((prev) => ({ ...prev, installmentImage: e }));
            }}
          />
        </div>
      </Modal.Body>
      <Modal.Footer style={{ marginBottom: 30 }}>
        <div style={{ width: "100%", display: "flex", gap: 10 }}>
          <Button
            variant="outline-primary"
            style={{ flex: 1 }}
            onClick={() => {
              onClose();
              setFormData();
            }}
          >
            ຍົກເລີກ
          </Button>
          <Button
            style={{ flex: 1 }}
            disabled={disableButton}
            onClick={() => {
              setDisableButton(true);
              onSubmit(installmentData?._id, {
                ...formData,
                installmentStatus: "SUCCESS",
              }).then(() => {
                setDisableButton(false);
                setFormData();
              });
            }}
          >
            ຢືນຢັນ
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
